import ErrorImg from '@/assets/imgs/unknown-error.svg';

import Auxiliary from '../Auxiliary';

interface UnknownErrorProps {
  handleClose: () => void;
}

export default function UnknownError({ handleClose }: UnknownErrorProps) {
  return (
    <Auxiliary
      screen="unknown-error"
      title="¡Ups! Algo ha ido mal..."
      subtitle="Por favor, vuelve a intentarlo."
      imgSrc={ErrorImg}
      mainButton="Volver"
      handleMainButton={() => handleClose()}
    />
  );
}
